module.exports = __webpack_public_path__ + "30d9092872bde7fabb08eceb9c2d1cb8.png";